module.exports = __webpack_public_path__ + "static/media/dejmark-logo.3398e719.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Article/ArticleCard/dejmark-logo.svg
// module id = 223
// module chunks = 1